// Frontend API configuration
// Uses REACT_APP_BACKEND_URL if set, otherwise uses relative URL (same domain)

const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // If env URL is set and not empty, use it
  if (envUrl && envUrl.trim() !== '') {
    return envUrl;
  }
  
  // Otherwise use relative URL (for production where frontend and backend are on same domain)
  // This returns empty string so API calls become relative (e.g., "/api/health")
  return '';
};

export const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;

export default { BACKEND_URL, API };
